/**
 * @file AddBtn
 */

'use strict';

/**
 * @classname BtnMemberApplyCancel
 * @classdesc BtnMemberApplyCancel
 */
export default class BtnMemberApplyCancel {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log(`BtnMemberApplyCancel.constructor`);
		this._$e = $e;
		this._memberApplyId = $e.attr('data-member-apply-id');
		this._memberId = $e.attr('data-member-id');
		this._memberName = $e.attr('data-member-name');
		const type = $e.attr('data-type');
		this._type = '';
		if(type === 'edit'){
			this._type = '変更';
		}else if(type === 'registration'){
			this._type = '新規登録';
		}else if(type === 'revival'){
			this._type = '復活';
		}
		console.log(this._type);
		this._$e.on('click', () => this.onClick());
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof AddBtn
	 * @return {undefined}
	 */
	onClick() {
		console.log(`BtnMemberApplyCancel.onClick`);
		$('.modal #member_apply_id').val(this._memberApplyId);
		$('.modal #member_name').text(this._memberName);
		$('.modal #member_id').val(this._memberId);
		$('.modal #apply_type').text(this._type);
		$('.modal #member_id_text').text(this._memberId);
	};
}
